import { reactive, readonly } from 'vue';

export type GeneralPurposeViewerType = 'viewer' | 'clipboard' | 'extractor';
export type GeneralPurposePositionType = 'fixed' | 'inline';

interface GeneralPurposeOverlayState {
  isOpen: boolean;
  viewerType: GeneralPurposeViewerType;
  positionType: GeneralPurposePositionType;
}

class OverlayManager {
  private static instance: OverlayManager;

  private readonly generalPurposeOverlayState
    = reactive<GeneralPurposeOverlayState>({
      isOpen: false,
      viewerType: 'viewer',
      positionType: 'fixed',
    });

  private constructor() {}

  static getInstance(): OverlayManager {
    if (!OverlayManager.instance) {
      OverlayManager.instance = new OverlayManager();
    }

    return OverlayManager.instance;
  }

  getGeneralPurposeOverlayState() {
    return readonly(this.generalPurposeOverlayState);
  }

  isGeneralPurposeOpen(): boolean {
    return this.generalPurposeOverlayState.isOpen;
  }

  openGeneralPurposeOverlay(): void {
    this.generalPurposeOverlayState.isOpen = true;
  }

  closeGeneralPurposeOverlay(): void {
    this.generalPurposeOverlayState.isOpen = false;
  }

  toggleGeneralPurposeOverlay(): void {
    this.generalPurposeOverlayState.isOpen
      = !this.generalPurposeOverlayState.isOpen;
  }

  setGeneralPurposeViewerType(viewerType: GeneralPurposeViewerType): void {
    this.generalPurposeOverlayState.viewerType = viewerType;
  }

  setGeneralPurposePositionType(
    positionType: GeneralPurposePositionType,
  ): void {
    this.generalPurposeOverlayState.positionType = positionType;
  }

  showGeneralPurposeOverlay(options?: {
    viewerType?: GeneralPurposeViewerType;
    positionType?: GeneralPurposePositionType;
  }): void {
    if (options?.viewerType) {
      this.generalPurposeOverlayState.viewerType = options.viewerType;
    }

    if (options?.positionType) {
      this.generalPurposeOverlayState.positionType = options.positionType;
    }

    this.generalPurposeOverlayState.isOpen = true;
  }
}

export const overlayManager = OverlayManager.getInstance();

export const useGeneralPurposeOverlayManager = (): OverlayManager =>
  overlayManager;
